import { createContext, JSX, PropsWithChildren } from 'react';
import { SearchFilterContentTypes, SearchOrigins } from 'search-gateway-client';

import { SearchBarVariant } from '../elements/NavSearchElements/searchUtils';

export interface NavSearchProps {
    contentType: SearchFilterContentTypes;
    onSubmit: (contentType: SearchFilterContentTypes, value: string, searchOrigin: SearchOrigins) => void;
    userHasAnySubscription: boolean;
    isEnterpriseMember: boolean;
    pproPluginEnabled: boolean;
    isSearchAppLoaded: () => boolean;
    imagesUrl: string;
    showSuggestions: boolean;
    setShowSuggestions: (value: boolean) => void;
    searchOrigin?: SearchOrigins;
    useSnapshots?: boolean;
    searchBarVariant: SearchBarVariant;
    className?: string;
}

export const NavSearchContext = createContext({} as NavSearchProps);

export function NavSearchContextProvider({ children, ...props }: PropsWithChildren<NavSearchProps>): JSX.Element {
    return <NavSearchContext.Provider value={props}>{children}</NavSearchContext.Provider>;
}

export const StatsigExperimentContext = createContext<Record<string, boolean>>({});
